var _a, _b;
// The lowercase version of `navigator.userAgent`.
// The `navigator` can be `undefined` in some cases. To avoid breaking, we should default to an empty string.
// To be able to mock the user agent in tests, it's moved to its own module.
export const userAgent = (((_a = window.navigator) === null || _a === void 0 ? void 0 : _a.userAgent) || '').toLowerCase();
/**
 * @deprecated `window.navigator.vendor` is deprecated.
 * https://developer.mozilla.org/en-US/docs/Web/API/Navigator/vendor
 */
export const vendor = (_b = window.navigator) === null || _b === void 0 ? void 0 : _b.vendor;
